export default {
  drawer: null,
  color: 'success',
  image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
  menuRoot: '',
  tempHistory: null,
  manualHistory: [],
  nextRoute: null,
  isFormChanged: false,
};
